import App from "./App"
import type { WidgetInitParams } from "./types"

// Initialize the queue for init calls that happen before the app is ready
if (typeof window.__onebuildInitQueue === "undefined") {
    window.__onebuildInitQueue = []
}

// Set up a stub window.onebuild object immediately so users can call init()
// even before the Preact app has mounted
if (typeof window.onebuild === "undefined") {
    window.onebuild = {
        init: (params: WidgetInitParams) => {
            // Queue the init call to be processed when the real object is ready
            if (typeof window.__onebuildInitQueue === "undefined") {
                window.__onebuildInitQueue = []
            }
            window.__onebuildInitQueue?.push(params)
        },
        // Stub methods that warn if called before init
        identify: () => {
            console.warn(
                "1build widget: identify() called before init(). Please call init() first.",
            )
        },
        open: () => {
            console.warn(
                "1build widget: open() called before init(). Please call init() first.",
            )
        },
        close: () => {
            console.warn(
                "1build widget: close() called before init(). Please call init() first.",
            )
        },
        on: () => {
            console.warn(
                "1build widget: on() called before init(). Please call init() first.",
            )
        },
        off: () => {
            console.warn(
                "1build widget: off() called before init(). Please call init() first.",
            )
        },
        checkout: () => {
            console.warn(
                "1build widget: checkout() called before init(). Please call init() first.",
            )
        },
        uoms: [],
    }
}

const existingElement = document.getElementById("preact_root")

if (existingElement === null) {
    const element = document.createElement("div")
    document.body.prepend(element)
}

export default App
